import { render, staticRenderFns } from "./EnrolmentAgreementItemEditor.vue?vue&type=template&id=60c13d5a&scoped=true"
import script from "./EnrolmentAgreementItemEditor.vue?vue&type=script&lang=js"
export * from "./EnrolmentAgreementItemEditor.vue?vue&type=script&lang=js"
import style0 from "./EnrolmentAgreementItemEditor.vue?vue&type=style&index=0&id=60c13d5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c13d5a",
  null
  
)

export default component.exports